import { logEvent } from "@/lib/analytics";

// Local-only demo progress tracking (Started / 25 / 50 / 75 / Completed).
const KEY = "recoveros_demo_progress";

export function getDemoProgress() {
  try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
}

function save(p) { try { localStorage.setItem(KEY, JSON.stringify(p)); } catch (e) { /* noop */ } }

export function isDemoCompleted() { return !!getDemoProgress().completed; }

export function markDemoStarted(source = "unknown") {
  const p = getDemoProgress();
  if (!p.started) {
    p.started = true; save(p);
    logEvent("demo_started", { source });
  }
}

// Call with the current watched percentage (0-100). Fires milestone + completion events once.
export function trackDemoPercent(pct, source = "unknown") {
  const p = getDemoProgress();
  let changed = false;
  for (const m of [25, 50, 75]) {
    if (pct >= m && !p[`m${m}`]) { p[`m${m}`] = true; changed = true; logEvent("demo_progress", { percent: m, source }); }
  }
  if (pct >= 90 && !p.completed) {
    p.completed = true; changed = true;
    logEvent("demo_completed", { source });
    try { window.dispatchEvent(new Event("recoveros:demo-completed")); } catch (e) { /* noop */ }
  }
  if (changed) save(p);
  return p;
}
